import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useForm } from "react-hook-form";
import GlobalHelmet from "./../../GlobalHelmet";
import { Link } from "react-router-dom";
import Breadcrumbs from "./../../component/breadcrumbs";
import Common from "./../../common.json";
import AllJsonData from "../../json/allData.json";
import Faq from "./Faq";

import { createBrowserHistory } from "history";
const history = createBrowserHistory({
  forceRefresh: true,
});

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));
export default function AddStrategies() {
  const classes = useStyles();
  const optiondata = AllJsonData?.optionData;
  const compareOption = AllJsonData?.compareOption;
  const [submitDisabled, setsubmitDisabled] = useState(false);

  const [inputList, setInputList] = useState([
    { weapon: "", rel: "", weapon2: "" },
  ]);
  const [inputList2, setInputList2] = useState([
    { cusweapon: "", cusrel: "", name: "" },
  ]);

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  const handleAddClick = () => {
    setInputList([...inputList, { weapon: "", rel: "", weapon2: "" }]);
  };

  const handleInput2Change = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList2];
    list[index][name] = value;
    setInputList2(list);
  };
  const handleRemove2Click = (index) => {
    const list = [...inputList2];
    list.splice(index, 1);
    setInputList2(list);
  };
  const handleAdd2Click = () => {
    setInputList2([...inputList2, { cusweapon: "", cusrel: "", name: "" }]);
  };

  // form validation rules
  const validationSchema = Yup.object().shape({});
  const { register, handleSubmit, reset } = useForm({
    resolver: yupResolver(validationSchema),
  });
  function onSubmit(fodata) {
    setsubmitDisabled(true);

    sessionStorage.setItem(
      "custom-condition",
      JSON.stringify({ inputList, inputList2 }, null)
    );

    history.push("/intraday-screener-stock");

    setsubmitDisabled(false);
  }

  return (
    <>
      <GlobalHelmet {...Common?.customizeScreener} />
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-lg-12">
              <Breadcrumbs page="Stock Screener" />

              <div className={classes.root}>
                <section className="contactCntr">
                  <div className="contactForm">
                    <div className="row">
                    <div className="col-sm-12">
                      <p>
                      Screener for stocks is a nice tool to find the best stocks for trading. There may be intraday screener, positional stock screener etc. Intraday screener is used to find the best live stocks for today trading. Apply different parameters in below boxes and select your criteria to find most hot stocks for today. It is a live stock screener which scans stocks for intraday trading, swing trading & positional trading. Its unique feature is its simplicity of criteria selection. In the upper box, you can compare parameters and in the other box, you can write values to related parameters like Market cap, % chg, average volume, price etc to get desired results.
                      </p>
                      </div>

                      <div className="col-sm-12">
                        <div className="contactLft">
                          <form
                            onSubmit={handleSubmit(onSubmit)}
                            onReset={reset}
                            method="post"
                          >
                            {inputList.map((x, i) => {
                              return (
                                <div className="row" key={i}>
                                  <div className="col-sm-3">
                                    <div className="form-group">
                                      <select
                                        ref={register}
                                        name="weapon"
                                        className="form-control"
                                        onChange={(e) =>
                                          handleInputChange(e, i)
                                        }
                                      >
                                        {optiondata.map((item) => (
                                          <option
                                            value={item.id}
                                            selected={
                                              item.id === x.weapon
                                                ? "selected"
                                                : ""
                                            }
                                            key={"weapon" + item.id}
                                          >
                                            {item.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-sm-3">
                                    <select
                                      ref={register}
                                      name="rel"
                                      className="form-control"
                                      onChange={(e) => handleInputChange(e, i)}
                                    >
                                      {compareOption.map((item) => (
                                        <option
                                          value={item.id}
                                          selected={
                                            item.id === x.weapon
                                              ? "selected"
                                              : ""
                                          }
                                          key={"rel" + item.id}
                                        >
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-sm-3">
                                    <div className="form-group">
                                      <select
                                        ref={register}
                                        name="weapon2"
                                        className="mt-17 form-control"
                                        onChange={(e) =>
                                          handleInputChange(e, i)
                                        }
                                      >
                                        {optiondata.map((item) => (
                                          <option
                                            value={item.id}
                                            selected={
                                              item.id === x.weapon2
                                                ? "selected"
                                                : ""
                                            }
                                            key={"weapon2" + item.id}
                                          >
                                            {item.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>

                                  <div className="btn-box">
                                    <div className="col-sm-1">
                                      {i === 0 ? (
                                        <button
                                          type="button"
                                          className="stategy-btn btn btn-sm btn-success"
                                          onClick={handleAddClick}
                                        >
                                          <i className="fa fa-plus"></i>
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-danger"
                                          onClick={() => handleRemoveClick(i)}
                                        >
                                          <i className="fa fa-remove"></i>
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}

                            {inputList2.map((x, i) => {
                              return (
                                <div className="row" key={i}>
                                  <div className="col-sm-3">
                                    <div className="form-group">
                                      <select
                                        ref={register}
                                        name="cusweapon"
                                        className="form-control"
                                        onChange={(e) =>
                                          handleInput2Change(e, i)
                                        }
                                      >
                                        {optiondata.map((item) => (
                                          <option
                                            value={item.id}
                                            selected={
                                              item.id === x.cusweapon
                                                ? "selected"
                                                : ""
                                            }
                                            key={"cusweapon" + item.id}
                                          >
                                            {item.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-sm-3">
                                    <select
                                      ref={register}
                                      name="cusrel"
                                      className="form-control"
                                      onChange={(e) => handleInput2Change(e, i)}
                                    >
                                      {compareOption.map((item) => (
                                        <option
                                          value={item.id}
                                          selected={
                                            item.id === x.weapon
                                              ? "selected"
                                              : ""
                                          }
                                          key={"cusrel" + item.id}
                                        >
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-sm-3">
                                    <div className="form-group">
                                      <input
                                        ref={register}
                                        name="name"
                                        type="type"
                                        placeholder="Enter  Name"
                                        value={x.name}
                                        onChange={(e) =>
                                          handleInput2Change(e, i)
                                        }
                                        className="form-control mt-17"
                                      />
                                    </div>
                                  </div>

                                  <div className="btn-box">
                                    <div className="col-sm-1">
                                      {i === 0 ? (
                                        <button
                                          className="stategy-btn btn btn-sm btn-success"
                                          type="button"
                                          onClick={handleAdd2Click}
                                        >
                                          <i className="fa fa-plus"></i>
                                        </button>
                                      ) : (
                                        <button
                                          className="btn btn-sm btn-danger"
                                          type="button"
                                          onClick={() => handleRemove2Click(i)}
                                        >
                                          <i className="fa fa-remove"></i>
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}

                            <div>
                              <Link
                                to="/stratergy/"
                                className="btn btn-primary"
                              >
                                Cancel
                              </Link>
                              &nbsp;&nbsp;
                              <input
                                type="submit"
                                name="submit"
                                disabled={submitDisabled}
                                className="btn btn-success"
                                defaultValue="SUBMIT &raquo;"
                              />
                              {submitDisabled ? (
                                <CircularProgress color="secondary" />
                              ) : (
                                ""
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                      <div className="col-md-12 mt-4">
                        <Faq />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
